import type { FaireProductEntity } from "../../entity_types/product";

export const p_xsc47wxygf: FaireProductEntity = {
  token: "p_xsc47wxygf",
  type: "product",
  name: "Moby Hip Seat - Heather Grey",
  brandToken: "b_c42572ac",
  brandName: "Moby",
  imageUrl: "https://cdn.faire.com/fastly/eb7044c2c8871921c53139cbee68ef08ee0ce96da734a8b392b3503002e1dbd4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/24f848f4bdc4a9f201a8252a172086e53ba038fabf9e9b71855756947163ba84.jpeg",
    "https://cdn.faire.com/fastly/1fe7de6f79e6f07ec571198117155bcda9161a665fdae44b956a6f015afdf6db.jpeg",
    "https://cdn.faire.com/fastly/5afb0b9be6e0092e479417480bf488f18e7cfbf0c5041c0b51cff3324a192694.jpeg",
    "https://cdn.faire.com/fastly/51191194cd2b29537da5a388d1226efa07cf62aff00db2f3e4094f207f502124.jpeg",
    "https://cdn.faire.com/fastly/83ea4a66fe335ed8cb94d6d11393312084fb823d9b5f8d3821e072c07c915d71.jpeg"
  ],
  priceDollars: 25,
  description: "• Adjustable waistband fits waist sizes 23\"-44\".\n• Intended for babies from 15-45 lbs.\n• Machine wash your carrier with gentle detergent using cold water and the gentle or delicate cycle.\n• We suggest placing the Hip Seat in a pillow case or mesh laundry bag to protect the buckles. Hang dry or use the lowest dryer setting.",
  tags: [],
  msrpDollars: 49.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:18.595Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
